<template>
  <el-card shadow="never">
    <template slot="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: $root.getDashboardPath() }">Dashboard</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'Facility Audit' }">Audit</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'Facility Audit credits'}">
          {{ $root.getHeader() }} Audit report for credit without payments
        </el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <el-card
      v-loading="loading"
      :body-style="{background: 'linear-gradient(35deg, #009aca, #0c3da7)', padding: '20px' }">
      <div slot="header" class="credit-header">
        <p class="wallet-head">
          Total Credits
        </p>
      </div>
      <h4 class="credit-text">
        {{ totalCredit }}
      </h4>
    </el-card>
    <el-divider></el-divider>
    <el-table :data="credits" v-loading="loading">
      <el-table-column label="Created At" :width="100">
        <template slot-scope="scope">
          {{ new Date(scope.row.createdAt).toLocaleString() }}
        </template>
      </el-table-column>
      <el-table-column label="Amount" prop="amount" :formatter="(row, column, cellValue ) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)" :width="110"></el-table-column>
      <el-table-column label="Created By" prop="createdBy"></el-table-column>
      <el-table-column label="For" prop="customer.company"></el-table-column>
      <el-table-column label="Description" prop="details" :width="350"></el-table-column>
      <el-table-column label="Voided" :width="100" >
        <template slot-scope="scope">{{ scope.row.status === 'voided' ? 'Yes' : 'No' }}</template>
      </el-table-column>
      <el-table-column label="Voided At" :width="100">
        <template slot-scope="scope" v-if="scope.row.voided">
          {{ new Date(scope.row.void.createdAt).toLocaleString() }}
        </template>
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
import axios from 'axios';
import { FACILITY_TRANSACTIONS_API_BASE } from '../env';

export default {
  name: 'Audit Credits',
  props: {
    facility: { type: String, required: true },
  },
  watch: {
    async facility() {
      this.loading = true;
      await this.getCredits();
      this.loading = false;
    },
  },
  async mounted() {
    this.loading = true;
    await this.getCredits();
    this.loading = false;
  },
  data() {
    return {
      credits: [],
      totalCredit: 0,
      loading: false,
    };
  },
  methods: {
    async getCredits() {
      const response = await axios.get(`${FACILITY_TRANSACTIONS_API_BASE}/v1/${this.facility}`, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
        params: {
          type: 'CREDIT_WITHOUT_PAYMENT',
        },
      });

      this.credits = response.data.result.transactions;

      this.totalCredit = this.$options.filters.currencySign(Number(this.credits.map(credit => credit.amount).reduce((cv, pv) => cv + pv, 0)), this.$root.state.facilityData);
    },
  },
};
</script>

<style scoped>
.credit {
  width: 480px;
}

.credit-text {
  color: #efefef;
  font-weight: 300;
}

.credit-head {
  font-weight: 400;
  margin: 0;
  color: #009aca;
}
</style>



// WEBPACK FOOTER //
// src/components/AuditCredits.vue